import { render, staticRenderFns } from "./WebChat.vue?vue&type=template&id=8e94db2e&scoped=true"
import script from "./WebChat.vue?vue&type=script&lang=js"
export * from "./WebChat.vue?vue&type=script&lang=js"
import style0 from "./WebChat.vue?vue&type=style&index=0&id=8e94db2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e94db2e",
  null
  
)

export default component.exports